// Import jQuery
import $ from 'jquery';

window.$ = $;

// Require Foundation modules
import 'foundation-sites/dist/js/plugins/foundation.orbit.min.js';
import 'foundation-sites/dist/js/plugins/foundation.tabs.min.js';
import './modules/AjaxPosts';
import './modules/MegaMenu';
import './modules/Newsletter';
import './modules/Search';
import './modules/SmoothScroll';
import './modules/ViewSwitch';
import './modules/Splide';
import GoogleTranslator from './modules/Google-translator';
import HeroHeader from './modules/Hero';


// IE fix

    import './modules/ObjectFitIE';
    
 


// -------------Uncomment if needed----------------------//
// -----------------------------------------------------//

// import 'foundation-sites/dist/js/plugins/foundation.core.min.js';
// import 'foundation-sites/dist/js/plugins/foundation.util.keyboard.min.js';
// import 'foundation-sites/dist/js/plugins/foundation.util.touch.min.js';
// import 'foundation-sites/dist/js/plugins/foundation.util.nest.min.js';
// import 'foundation-sites/dist/js/plugins/foundation.util.box.min.js';
// import 'foundation-sites/dist/js/plugins/foundation.util.triggers.min.js';
// import 'foundation-sites/dist/js/plugins/foundation.util.mediaQuery.min.js';
// import 'foundation-sites/dist/js/plugins/foundation.util.motion.min.js';
// import 'foundation-sites/dist/js/plugins/foundation.util.imageLoader.min.js'; // Uncomment if needed
// import 'foundation-sites/dist/js/plugins/foundation.reveal.min.js';
// import 'foundation-sites/dist/js/plugins/foundation.accordion.min.js';
// import 'foundation-sites/dist/js/plugins/foundation.accordionMenu.min.js';
// import 'foundation-sites/dist/js/plugins/foundation.tooltip.min.js';
 import 'foundation-sites/dist/js/plugins/foundation.offcanvas.min.js';
// import 'foundation-sites/dist/js/plugins/foundation.drilldown.min.js';
// import 'foundation-sites/dist/js/plugins/foundation.sticky.min.js';
// import 'foundation-sites/dist/js/plugins/foundation.dropdownMenu.min.js';
// import 'foundation-sites/dist/js/plugins/foundation.dropdown.min.js';
// Import custom modules
// import './modules/Animation';
// import './modules/ExternalLinks';
//import './modules/Tabs';


// Initialize Foundation
$(document).foundation();

$(document).ready(function() {
    new HeroHeader();
    new GoogleTranslator();
 });